

/*
FrFr FRIENDLY FRAMEWORK
frfr-virtel-selectors
Version ID: 1a 2024-01-19r1
by 
// Please describe here if you customized this file
*/


export const select_virtel_single_by_subkey = (virbom_seq, subkey) => {
  let bingo_virtel = false;
  if (subkey > 0 && Array.isArray(virbom_seq)) {
    virbom_seq.forEach(virtel => {
      if (virtel.subkey === subkey) {
        bingo_virtel = virtel;
      }
    });
  } else {
    return false;
  }
  return bingo_virtel;
};


export const select_virtel_where_parent_subkey = (virbom_seq, parent_subkey) => {
  // select all virtel with same parent
  // let selection = null;
  let selection = null;
  if ((parent_subkey > 0 || parent_subkey === null) && Array.isArray(virbom_seq)) {
    selection = virbom_seq.filter(virtel => {
      if (virtel.parent_subkey === parent_subkey) {
        return true;
      }
      return false;
    });
  } else {
    return [];
  }
  return selection;
};


export const select_virtel_where_virtelschemakey = (virbom_seq, virtelschemakey) => {
  // select all modules with same parent
  let selection = null;
  if (typeof virtelschemakey === 'string' && virtelschemakey !== '' && Array.isArray(virbom_seq)) {
    selection = virbom_seq.filter(virtel => {
      if (virtel.virtelschemakey === virtelschemakey) {
        return true;
      }
      return false;
    });
  } else {
    return [];
  }
  return selection;
};

